import './styles.scss';

import { IModalBaseProps } from '@components/common/Modal/Modal';
import { Modal, Typography } from 'antd';
import React, { ReactNode } from 'react';

export interface IModalConfirmProps extends IModalBaseProps {
  mode: 'confirm';
  text?: string | ReactNode;
  submitText?: string;
  cancelText?: string;
  width?: string | number;
  strict?: boolean;
}

export const ModalConfirm: React.FC<IModalConfirmProps> = ({
  open,
  onSubmit,
  onCancel,
  text,
  submitText = 'Да',
  cancelText = 'Нет',
  width,
  strict,
  confirmLoading = false,
  footer,
  destroyOnHidden,
}: IModalConfirmProps) => {
  return (
    <Modal
      open={open}
      width={width}
      onOk={onSubmit}
      onCancel={onCancel}
      okText={submitText}
      cancelText={cancelText}
      confirmLoading={confirmLoading}
      footer={footer}
      maskClosable={!strict}
      keyboard={!strict}
      closable={!strict}
      destroyOnHidden={destroyOnHidden}>
      {typeof text === 'string' ? (
        <Typography.Paragraph className="modal-text">{text}</Typography.Paragraph>
      ) : (
        text
      )}
    </Modal>
  );
};
